// extracted by mini-css-extract-plugin
module.exports = {"search_grid_container":"search-result-grid_search_grid_container__12KSQ","heading_section":"search-result-grid_heading_section__2u0k6"};